import { ApolloError } from 'apollo-client';
import { useMemo } from 'react';
import { useToggleable } from '../hooks';

export const usePaymentMethodsError = (errors: ApolloError) => {
	const { isOpen, setOpen, close } = useToggleable(false);

	useMemo(() => !!errors && setOpen(true), [errors]);

	const errorMessage = errors?.graphQLErrors.find(item => {
		return item.message?.startsWith('Sirena2_');
	})?.message;

	return {
		isOpen,
		errorMessage,
		close
	};
};
